const initialState = {

}

const session = (state = initialState, data) => {
    if (data.action === 'SET_SEARCH' && data.value) {
        return {
            ...data.value,
        }
    }
    return state
}

export default session;